import React, { Component } from "react";
import vwdata from "../scripts/analytics";
import WOW from 'wowjs';
import Slider from "react-slick";
import { each } from "jquery";

class SliderSlide extends Component {

  componentDidMount() {
    
  }
  
  flipSide(){
    var darkMode = window.sessionStorage.getItem("darkMode");
    var nextSide;
    var curSide;

    if(darkMode == "true"){
      window.sessionStorage.setItem("darkMode", "false");
      curSide = "Side B - Dark";
      nextSide = "Side A - Light";
      
    }else{
      window.sessionStorage.setItem("darkMode", "true");
      curSide = "Side A - Light";
      nextSide = "Side B - Dark";
    }
    window.scrollTo(0,0);
    
    vwdata.push({
      eventInfo: {
        eventAction: "VWBasic_Button_Click",
        pageName: "Car Cover",
        pageCategory: curSide,
      },
      user: {
        browserResolutionHeight: window.innerHeight.toString(),
        browserResolutionWidth: window.innerWidth.toString(),
      },
      link: {
        url: '/',
        name: nextSide,
    }
    });


    window.location.reload();
  }

  render() {
    var headerText = this.props.header;
    var animatedHeaderText = this.props.animatedHeaderText;
    var captionText = this.props.caption;
    var animatedCaptionText = this.props.animatedCaptionText;
    var headerBorder = this.props.headerBorder;
    var captionBorder = this.props.captionBorder;
    var ctaText = this.props.ctaText;
    var animatedBackground = this.props.animatedBackground;
    var backgroundImg = this.props.backgroundImg;

    var darkMode = window.sessionStorage.getItem("darkMode");

    let addBkgClass;
    let carAnimation;
    if(!animatedBackground){
      addBkgClass = "backgroundFill"; 
    }

    let headerTextCode;
    if(headerText){
      headerTextCode = headerText;
    }else{
      headerTextCode = "";
    }


    let animatedHeaderTextCode;
    if(animatedHeaderText){
      var splitHeader = this.props.animatedHeaderText.split(" ");
      splitHeader.forEach((el,i)=>{
        var animDel = i*.1;
        animDel++;
        el="<span class='animatedHeader' style='animation-delay:"+animDel+"s'>"+el+"</span>";
        //el="<span class='animatedHeader'>"+el+"</span>";
        splitHeader[i]=el;
      });
      var combinedHeader = "";
      splitHeader.forEach((el,i)=>{
        if(i != (splitHeader.length-1)){
          el=el+" ";
        }
        combinedHeader+=el;
      });
      
      
      
      //animatedHeaderTextCode = '<span class="animatedHeader">'+this.props.animatedHeaderText+'</span>'
      animatedHeaderTextCode = combinedHeader;
    }else{
      animatedHeaderTextCode = '';
    }

    let captionTextCode;
    if(captionText){
      captionTextCode = captionText;
    }else{
      captionTextCode = "";
    }

    
    let animatedCaptionTextCode;
    if(animatedCaptionText){
      animatedCaptionTextCode = '<span class="animatedCaption">'+this.props.animatedCaptionText+'</span>'
    }else{
      animatedCaptionTextCode = '';
    }

    let ctaFlag;
    let ctaTextCode;
    // if(ctaText){
    //   //ctaLinkCode = '<br/><button class="captionCta" type="button" onClick={this.flipSide}>'+this.props.ctaText+'<button/>';
    //   ctaLinkCode = <button onClick={this.flipSide}>test</button>
    // }else{
    //   ctaLinkCode = '';
    // }

    if(!ctaText){
      ctaFlag = "noShow";
      ctaTextCode = "";
    }else{
      ctaFlag = "";
      ctaTextCode = this.props.ctaText;
    }

    let headerBorderCode;
    let vwBorderCode;
    let h1ClassName;
    if (headerBorder){
      headerBorderCode = "headerContainer headerBorder";
      h1ClassName = "animatedP";
      vwBorderCode = "displayNone";
    }else{
      headerBorderCode = "headerContainer";
      vwBorderCode = "vwBorder";
    }

    let captionBorderCode;
    if (captionBorder ){
      captionBorderCode = "captionContainer captionBorder";
    }else{
      captionBorderCode = "captionContainer";
    }

    var headerCode = headerTextCode + animatedHeaderTextCode;
    var captionCode = captionTextCode + animatedCaptionTextCode;
    var bkgClassName = "slideContainer " + addBkgClass;

    if(backgroundImg){
      bkgClassName += " animatedBg";
    }
    
    return (
      
    // <div className={bkgClassName} style={{backgroundImage: `url(${backgroundImg})`}}>
    <div className={bkgClassName}>
    {/* <div className="slideContainer" style={"backgorundImage: url("+ backgroundImg+")"}> */}
      
      <div className="contentContainer">
        <div className={vwBorderCode}>
          <div className="vwBorder--before"></div>
          <a href="https://vw.ca" target="_blank">vw logo</a>
          <div className="vwBorder--after"></div>
          </div>
            <div className={headerBorderCode}>
                <h1 className="animatedP" dangerouslySetInnerHTML={{__html: headerCode}}></h1>
            </div>
            <div className={captionBorderCode}>
                <div className="animatedP" dangerouslySetInnerHTML={{__html: captionCode}}></div>
                <button className={"captionCta "+ctaFlag+""} onClick={this.flipSide}>{ctaTextCode}<div className="arrow arrow--right"></div></button>
                
            </div>
            <div className="arrow arrow--down"></div>
      </div>
    </div>
    );
  }
}

export default SliderSlide;